import { render, staticRenderFns } from "./PageLayoutFull.vue?vue&type=template&id=a334968e&scoped=true&"
import script from "./PageLayoutFull.vue?vue&type=script&lang=js&"
export * from "./PageLayoutFull.vue?vue&type=script&lang=js&"
import style0 from "./PageLayoutFull.vue?vue&type=style&index=0&id=a334968e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a334968e",
  null
  
)

export default component.exports